// Debug utility: force all loading-aware components to show their skeleton state.
// Toggle via URL: append ?skeletons to any page (persists to localStorage).
// Clear via ?skeletons=false or localStorage.removeItem('beacon_force_skeletons').

const params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : null

if (params?.has('skeletons')) {
  const val = params.get('skeletons')
  if (val === 'false' || val === '0') {
    localStorage.removeItem('beacon_force_skeletons')
  } else {
    localStorage.setItem('beacon_force_skeletons', 'true')
  }
}

export const FORCE_SKELETONS = typeof window !== 'undefined' && localStorage.getItem('beacon_force_skeletons') === 'true'

export function useForceLoading(loading?: boolean): boolean {
  return loading || FORCE_SKELETONS
}
